import React, { useState, useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import twilioClient from '../../utils/twilioClient';
import MyNumbersList from './MyNumbersList';
import BuyNumberPanel from './BuyNumberPanel';

const { FiPhone, FiShoppingCart } = FiIcons;

const TwilioNumbersView = () => {
  const [activeTab, setActiveTab] = useState('my-numbers');
  const [ownedNumbers, setOwnedNumbers] = useState([]);

  // Function to refresh owned numbers
  const refreshOwnedNumbers = async () => {
    try {
      const data = await twilioClient.getNumbers();
      setOwnedNumbers(data.numbers || []);
    } catch (error) {
      console.error('Failed to refresh owned numbers:', error);
    }
  };

  // Load numbers on component mount
  useEffect(() => {
    refreshOwnedNumbers();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex border-b border-gray-200">
        <button 
          className={`py-2 px-4 font-medium text-sm focus:outline-none ${
            activeTab === 'my-numbers' 
              ? 'border-b-2 border-blue-500 text-blue-600' 
              : 'text-gray-500 hover:text-gray-700'
          }`} 
          onClick={() => setActiveTab('my-numbers')}
        >
          <div className="flex items-center">
            <SafeIcon icon={FiPhone} className="mr-2" />
            My Numbers
          </div>
        </button>
        <button 
          className={`py-2 px-4 font-medium text-sm focus:outline-none ${
            activeTab === 'buy-number' 
              ? 'border-b-2 border-blue-500 text-blue-600' 
              : 'text-gray-500 hover:text-gray-700'
          }`} 
          onClick={() => setActiveTab('buy-number')}
        >
          <div className="flex items-center">
            <SafeIcon icon={FiShoppingCart} className="mr-2" />
            Buy New Number
          </div>
        </button>
      </div>
      
      {activeTab === 'my-numbers' ? (
        <MyNumbersList onRefresh={refreshOwnedNumbers} />
      ) : (
        <BuyNumberPanel onPurchaseSuccess={refreshOwnedNumbers} />
      )}
    </div>
  );
};

export default TwilioNumbersView;